import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericApiError } from '@/_shared/types/apiError';
import { API_SET_ORGANIZATION, KEY_PUT_SET_ORGANIZATION } from '../constants';
import { MOCK_RESPONSE_PUT_SET_ORGANIZATION } from '../mocks';
import { getCurrentOrganization } from '../selectors';

export type CallParamsPutSetOrganization = {
  organization: string;
  userId: string;
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponsePutSetOrganization = unknown;

type CallErrorPutSetOrganization = GenericApiError;

type CallSelectorsPutSetOrganization = unknown;

const responseMapper = () => ({
  status: 'OK',
});

export const putSetOrganizationCall = createGeneralCall<
  CallParamsPutSetOrganization,
  CallResponsePutSetOrganization,
  CallErrorPutSetOrganization,
  CallSelectorsPutSetOrganization
>({
  id: KEY_PUT_SET_ORGANIZATION,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_SET_ORGANIZATION(org as unknown as string);
  },
  method: 'put',
  paramsSelector:
    ({ payload }) =>
    () =>
      payload,
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_PUT_SET_ORGANIZATION : undefined,
  responseMapper,
  responseExtractor: null,
});
